<script>
    import  { Bar }  from 'vue-chartjs';
    export default {
        extends: Bar,
        props: ['data', 'options'],
        data(){
            return {
                localOptions: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 0,
                        }
                    },
                    legend: {
                        display: false,
                        labels: {
                            padding: 20,
                        },

                    },
                    tooltips: {
                        bodyFontSize: 18,
                        titleFontSize: 18,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontStyle: 'bold',
                                beginAtZero: true,
                                fontSize: 14,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontSize: 14,
                                fontStyle: 'bold',
                                padding: 10,
                            },
                        }]
                    },
                    plugins: {
                        datalabels: {
                            anchor: 'end',
                            align: 'top',
                            formatter: Math.round,
                            font: {
                                weight: 'bold'
                            }
                        }
                    },
                    animation: {
                        duration: 1,
                        onComplete: function () {
                            var chartInstance = this.chart,
                                    ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize,
                                    Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'center';
                            ctx.fillStyle = 'rgba(0, 0, 0, 1)';
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y + 15);
                                });
                            });
                        }
                    },

                },
            };
        },
        mounted () {
            var mergedObject = Object.assign({}, this.localOptions, this.options);
            this.renderChart(this.data, mergedObject);
        }
    };
</script>